const providers = [
  {
    provider: 'google',
    text: 'Google',
    tooltipText: 'Use Google account to Sign up',
  },
  {
    provider: 'apple',
    text: 'Apple',
    tooltipText: 'Use Apple account to Sign up',
  },
];

export default providers;
